module.exports = __webpack_public_path__ + "img/22@2x.6f976f64.png";